import React, { useState } from 'react';
import { useTheme } from '../ThemeContext';
import SetupScreen from './SetupScreen';
import { acceptHomeownerTerms } from '../utils/homeownerApi';
import { TERMS_UPDATE_BUTTON, TERMS_UPDATE_SUMMARY } from '../shared/consentCopy';

const linkStyle = { color: '#0f766e', fontWeight: 650 };

/** Blocks the dashboard until the current terms version is accepted. */
const HomeownerTermsUpdate = ({ onDone, onLogout }) => {
  const { colors } = useTheme();
  const [accepted, setAccepted] = useState(false);
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!accepted) return;
    setSaving(true);
    setError('');
    try {
      await acceptHomeownerTerms();
      if (onDone) await onDone();
    } catch (saveError) {
      setError(saveError.message || 'Could not save your acceptance. Please try again.');
      setSaving(false);
    }
  };

  return (
    <SetupScreen centered>
      <form
        onSubmit={handleSubmit}
        style={{
          width: '100%',
          maxWidth: '32rem',
          background: colors.surface,
          border: `1px solid ${colors.border}`,
          borderRadius: '1rem',
          padding: '1.5rem',
          color: colors.text,
          fontSize: '1rem',
          lineHeight: 1.45,
        }}
      >
        <p style={{ marginTop: 0 }}>
          {TERMS_UPDATE_SUMMARY}
          {' '}
          <a href="/terms" target="_blank" rel="noopener noreferrer" style={linkStyle}>View changes</a>
        </p>
        <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'flex-start', flexWrap: 'wrap' }}>
          <label style={{ display: 'flex', gap: '0.75rem', alignItems: 'flex-start', flex: '1 1 16rem' }}>
            <input
              type="checkbox"
              checked={accepted}
              onChange={(event) => setAccepted(event.target.checked)}
              style={{ marginTop: '0.2rem', width: '1.1rem', height: '1.1rem', flexShrink: 0 }}
            />
            <span>
              I agree to the updated{' '}
              <a href="/terms" target="_blank" rel="noopener noreferrer" style={linkStyle}>Terms of Service</a>
              {' '}
              and have read the{' '}
              <a href="/privacy" target="_blank" rel="noopener noreferrer" style={linkStyle}>Privacy Policy</a>.
            </span>
          </label>
          <button
            type="submit"
            disabled={!accepted || saving}
            style={{
              padding: '0.85rem 1.1rem',
              border: 'none',
              borderRadius: '0.5rem',
              background: '#59c4c4',
              color: 'white',
              fontWeight: 700,
              fontSize: '1rem',
              cursor: !accepted || saving ? 'not-allowed' : 'pointer',
              opacity: !accepted || saving ? 0.55 : 1,
            }}
          >
            {saving ? 'Saving...' : TERMS_UPDATE_BUTTON}
          </button>
        </div>
        {error ? <p role="alert" style={{ color: '#b91c1c' }}>{error}</p> : null}
        {onLogout && (
          <button
            type="button"
            onClick={onLogout}
            style={{
              width: '100%',
              marginTop: '0.75rem',
              padding: '0.85rem',
              borderRadius: '0.5rem',
              border: `1px solid ${colors.border}`,
              background: 'transparent',
              color: colors.text,
              fontSize: '1rem',
              cursor: 'pointer',
            }}
          >
            Log out
          </button>
        )}
      </form>
    </SetupScreen>
  );
};

export default HomeownerTermsUpdate;
